export enum ItemModel {
  Question = 'Question',
  Note = 'Note',
  Worksheet = 'Worksheet',
  Resource = 'Resource',
  Formula = 'Formula',
  IFrame = 'IFrame',
  WebViewer = 'Browser',
  Mario = 'Mario',
  Chat_GPT = 'Chat_GPT',
  RemoteVideo = 'REMOTEVIDEO',
  ResourceLoading = 'ResourceLoading',
  PDF = 'PDF',
  Image = 'Image',
  Video = 'Video',
  StickyNote = 'StickyNote',
  Line = 'Line',
  PDFImages = 'PdfImages',
  PDFImage = 'PdfImage',
}
